export const ShowTotalForTablePagination = (
	total: number,
	range: [number, number]
) => <>{`${range[0]}-${range[1]} of ${total} items`}</>;
